module.exports = __webpack_public_path__ + "static/media/space-station-moon.7cd7c2c6.svg";